<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <!-- Actions -->

    <div class="page_title" *ngIf="configuration.showSubmitButton">
        <div class="row">

            <div class="col_content y_items_center">

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <ng-container [formGroup]="form">

        <div class="row ligne_form">
            <div class="col_12">

                <!-- Sélection de la période -->

                <div class="form-group date_range">
                    <label>{{'promotion.period.select.action.value' | translate}}</label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate readonly [placeholder]="'filter.dateInterval.start.value' | translate" formControlName="dateStart" (click)="picker.open()">
                        <input matEndDate  readonly [placeholder]="'filter.dateInterval.end.value' | translate" formControlName="dateEnd" (click)="picker.open()">
                    </mat-date-range-input>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <div class="row">
                        <div class="col_6">
                            <mat-error *ngIf="form.get('dateStart').errors && (form.get('dateStart').dirty || form.get('dateStart').touched)">
                                <div class="invalid-feedback">
                                    <div *ngIf="form.get('dateStart').errors.required">{{ 'promotion.period.dateStart.required.value' | translate }}</div>
                                </div>
                            </mat-error>
                        </div>
                        <div class="col_6">
                            <mat-error *ngIf="form.get('dateEnd').errors && (form.get('dateEnd').dirty || form.get('dateEnd').touched)">
                                <div class="invalid-feedback">
                                    <div *ngIf="form.get('dateEnd').errors.required">{{ 'promotion.period.dateEnd.required.value' | translate }}</div>
                                </div>
                            </mat-error>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row ligne_form">
            <div class="col_12">

                <!-- Sélection du statut -->

                <div class="form-group">
                    <mat-select formControlName="status">
                        <mat-option value="">-</mat-option>
                        <mat-option *ngFor="let status of statusItems$ | async" [value]="status.value">
                            {{ status.label | translate }}
                        </mat-option>
                    </mat-select>
                    <mat-label>{{ 'promotion.period.status.select.action.value' | translate }}</mat-label>
                    <mat-error *ngIf="form.get('status').errors && (form.get('status').dirty || form.get('status').touched)">
                        <div class="invalid-feedback">
                            <div *ngIf="form.get('status').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                        </div>
                    </mat-error>
                </div>
            </div>
        </div>

        <div class="row ligne_form">
            <div class="col_12">

                <!-- Sélection des jours exclus -->

                <div class="row ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'promotion.period.excludedDays.select.action.value' | translate}}</label>
                            <div class="checkbox" *ngFor="let day of days">
                                <input type="checkbox" id="day-{{day.index}}" [value]="day.index" (change)="handleExcludedDay($event)">
                                <label for="day-{{day.index}}">{{ day.label | translate }}</label>
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </ng-container>

</form>
